<div
  class="min-h-screen min-w-[100vw] bg-primary-100 flex items-center justify-center"
>
  <div class="col-span-12 md:col-span-6 lg:col-span-4">
    <div class="container">
      <p-card styleClass="w-full">
        <i class="pi pi-bell text-3xl" pBadge value="1"></i><h2 class="
        mt-4 text-xl font-bold"> Tienes un contrato pendiente de firma</h2>
        <p class="mt-4">
          Hola {{this.op()?.seller?.name}} has recibido una solicitud de firma para formalizar el contrato de tu compraventa en Luxoro
        </p>
        <p class="my-4">Introduce el número de tu documento de identidad aportado para generar el contrato y firmarlo</p>
        <input type="text" pInputText [(ngModel)]="inputPass" placeholder="Número" class="w-full"/>
        <div class="mt-8">
            <p-button label="Acceder al contrato" [loading]="loading" (onClick)="validateAccess()" ></p-button>
        </div>
      </p-card>
    </div>
  </div>
</div>
